import mixpanel from "@/utils/mixpanel";
import webengage from "@/webengage";
import Image from "next/image";
import Link from "next/link";

export default function Support() {
  return (
    <section className="space-y-4">
      <h4 className="font-semibold text-2xl">
        For more details about the course
      </h4>
      <p className="text-lg">
        If you have any question regarding the course and couldn't find the
        answer on this page, feel free to contact us
      </p>
      <h4 className="font-semibold">Message us on Whatsapp</h4>
      <div className="flex items-center gap-2 w-full">
        <Image
          alt="Whatsapp"
          src="/img/whatsapp-icon.svg"
          width={40}
          height={40}
        />
        <div className="flex flex-col justify-start items-start gap-0">
          <Link
            href={"https://wa.me/919056187997"}
            target="_blank"
            className="font-semibold text-black"
            onClick={() => {
              const _webengage = webengage();
              if (_webengage) {
                _webengage.track("Contact Us", {
                  source: "Astrolearn",
                  type: "Chat",
                });
              }
              mixpanel.track("message_whatsapp", {
                page_location: "bootcamp support",
              });
            }}
          >
            +91 9056187997
          </Link>
          <p>Working Hours (10 AM - 10 PM)</p>
        </div>
      </div>
    </section>
  );
}
